'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect, useCallback } from 'react';
import { Container, AccordionSummary, IconWrapper, AccordionDetails } from './styled.js';
import { getTextNodeHeight } from './helpers.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useTransition from '../hooks/useTransition.js';

function Accordion(_a) {
    var title = _a.title, expandIcon = _a.expandIcon, children = _a.children, _b = _a.expand, expand = _b === void 0 ? true : _b, custom = _a.custom, settings = _a.settings, onChange = _a.onChange, rest = __rest(_a, ["title", "expandIcon", "children", "expand", "custom", "settings", "onChange"]);
    var _c = settings || {}, _d = _c.contentOffset, contentOffset = _d === void 0 ? 0 : _d, _e = _c.haveDefaultBackgroundColor, haveDefaultBackgroundColor = _e === void 0 ? true : _e;
    // Collapse state
    var _f = useState(expand), isExpand = _f[0], setExpand = _f[1];
    // Element ref
    var collapsibleContentRef = useRef(null);
    var contentRef = useRef(null);
    // Height of collapsible content
    var contentExpandHeightRef = useRef(0);
    var _g = useState(0), contentCollapseHeight = _g[0], setContentCollapseHeight = _g[1];
    // Store previous value of collapse state
    var prevValue = useRef(expand);
    var TitleComponent = title && typeof title === 'function' ? title(isExpand) : title;
    var isHaveExpandIcon = !!expandIcon;
    useEffect(function () {
        if (prevValue.current !== expand) {
            setExpand(expand);
        }
    }, [expand]);
    useEffect(function () {
        prevValue.current = isExpand;
    }, [isExpand]);
    useEffect(function () {
        var handleExpandContent = function () {
            var _a;
            if (contentRef.current && collapsibleContentRef.current) {
                var collapsibleContentEl = collapsibleContentRef.current;
                /*
                 * Handle action if enable viewMoreShadow
                 * */
                var lineHeight = getTextNodeHeight(collapsibleContentEl.childNodes[0], (_a = custom === null || custom === void 0 ? void 0 : custom.enable) !== null && _a !== void 0 ? _a : false).lineHeight;
                var contentHeight = contentRef.current.scrollHeight + contentOffset;
                if (isExpand) {
                    var maxHeight = 0;
                    if (custom === null || custom === void 0 ? void 0 : custom.enable) {
                        maxHeight += lineHeight * (custom === null || custom === void 0 ? void 0 : custom.numberOfLine);
                        if (contentCollapseHeight !== maxHeight) {
                            setContentCollapseHeight(maxHeight);
                        }
                        return;
                    }
                }
                contentExpandHeightRef.current = contentHeight;
            }
        };
        document.fonts.ready.then(function () {
            handleExpandContent();
        });
        // Observe changes of collapsible content
        if (collapsibleContentRef.current) {
            var observer_1 = new MutationObserver(handleExpandContent);
            observer_1.observe(collapsibleContentRef.current, {
                childList: true,
                subtree: true
            });
            return function () {
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [isExpand, expand, children, contentCollapseHeight]);
    // Handle transition of collapsible
    var styles = useTransition({
        open: !isExpand,
        args: {
            expandHeight: contentExpandHeightRef.current,
            collapseHeight: contentCollapseHeight,
            enableCustom: (custom === null || custom === void 0 ? void 0 : custom.enable) || false
        }
    }, {
        initial: function (_a) {
            var collapseHeight = _a.collapseHeight, enableCustom = _a.enableCustom;
            return {
                height: collapseHeight,
                opacity: enableCustom ? 1 : 0
            };
        },
        enter: function (_a) {
            var expandHeight = _a.expandHeight;
            return {
                height: expandHeight,
                opacity: 1
            };
        },
        entered: {
            height: 'auto',
            opacity: 1
        },
        beforeLeave: function (_a) {
            var expandHeight = _a.expandHeight;
            return {
                height: expandHeight,
                opacity: 1
            };
        },
        leave: function (_a) {
            var collapseHeight = _a.collapseHeight, enableCustom = _a.enableCustom;
            return {
                height: collapseHeight,
                opacity: enableCustom ? 1 : 0
            };
        }
    }).styles;
    var handleHeaderAction = useCallback(function () {
        setExpand(function (prevState) {
            onChange && onChange(!prevState);
            return !prevState;
        });
    }, [onChange]);
    return (React__default.createElement(Container, __assign({ isExpand: isExpand, haveDefaultBackgroundColor: haveDefaultBackgroundColor }, rest),
        React__default.createElement(AccordionSummary, { className: 'accordion__summary', onClick: handleHeaderAction, "$isHaveExpandIcon": isHaveExpandIcon },
            TitleComponent,
            expandIcon ? (React__default.createElement(IconWrapper, { className: 'accordion__summary--icon', isExpand: isExpand }, expandIcon)) : null),
        React__default.createElement(AccordionDetails, { ref: collapsibleContentRef, isExpand: isExpand, style: styles },
            React__default.createElement("div", { style: { marginTop: contentOffset }, ref: contentRef }, children))));
}

export { Accordion as default };
//# sourceMappingURL=index.js.map
